import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { RequisitionActionModalComponent } from 'src/app/pages/mission-control-page/requisitions-page/requisition-card/requisition-action-modal/requisition-action-modal.component';

@Injectable({
  providedIn: 'root'
})
export class RequisitionActionModalService {

  requisitionActionModal!: BsModalRef;

  constructor(private bsModalService: BsModalService) { }

  show(modalData: any): void {
    const config = new ModalConfig();
    config.class = 'modal-lg custom-ngx-feedback-form-modal';
    config.initialState = modalData;
    this.requisitionActionModal = this.bsModalService.show(RequisitionActionModalComponent, config);
  }
}
